import { ViewerActions } from "actions";
import ViewerEvents from "events/ViewerEvents";
import EventsEmitter from "./EventsEmitter";
const initialCrossSectionBounds = {
    xPosition: { value: 500, min: 0, max: 1000, step: 3 },
    yPosition: { value: 500, min: 0, max: 1000, step: 3 },
    zPosition: { value: 500, min: 0, max: 1000, step: 3 },
    wPosition: { value: 500, min: 0, max: 1000, step: 3 },
    width: { value: 0, min: 0, max: 1000, step: 3 },
    blockModelWidth: { value: 0, min: 0, max: 1000, step: 3 },
    drillHolesWidth: { value: 0, min: 0, max: 1000, step: 3 },
    xDip: { value: 0, min: 0, max: 360, step: 5 },
    xDipAzimuth: { value: 0, min: 0, max: 360, step: 5 },
    yDip: { value: 0, min: 0, max: 360, step: 5 },
    yDipAzimuth: { value: 0, min: 0, max: 360, step: 5 },
    zDip: { value: 0, min: 0, max: 360, step: 5 },
    zDipAzimuth: { value: 0, min: 0, max: 360, step: 5 },
    wDip: { value: 0, min: 0, max: 360, step: 5 },
    wDipAzimuth: { value: 0, min: 0, max: 360, step: 5 },
};

export default class CrossSectionBounds extends EventsEmitter {
    static viewBounds: any = [];
    static previousCrossSectionBoundsLayerId = "";
    static crossSectionBounds: any;
    static worldOriginMin: any;
    static initializeBounds: boolean = false;

    static onCrossSectionChange(event: any) {
        //console.log("onCrossSectionChange:", event);
        const { planeId, planeMinValue, planeMaxValue, planeStepValue, planeValue, planeData } = event;
        if (planeData && planeData.worldOriginMin) {
            CrossSectionBounds.worldOriginMin = planeData.worldOriginMin;
        }
        switch (planeId) {
            case "CrossSectionX":
                CrossSectionBounds.refreshCrossSectionPositionSlider(
                    "x",
                    planeMinValue,
                    planeMaxValue,
                    planeStepValue,
                    planeValue
                );
                break;
            case "CrossSectionY":
                CrossSectionBounds.refreshCrossSectionPositionSlider(
                    "y",
                    planeMinValue,
                    planeMaxValue,
                    planeStepValue,
                    planeValue
                );
                break;
            case "CrossSectionZ":
                const worldOrginZ = CrossSectionBounds.worldOriginMin[2];
                CrossSectionBounds.refreshCrossSectionPositionSlider(
                    "z",
                    planeMinValue + worldOrginZ,
                    planeMaxValue + worldOrginZ,
                    planeStepValue,
                    planeValue + worldOrginZ
                );
                break;
            case "CrossSectionW":
                CrossSectionBounds.refreshCrossSectionPositionSlider(
                    "w",
                    planeMinValue,
                    planeMaxValue,
                    planeStepValue,
                    planeValue
                );
                break;
        }
        EventsEmitter.emit("updateSliders", {});
    }

    static getViewBounds() {
        return CrossSectionBounds.viewBounds;
    }

    static initCrossSectionBounds(viewMeta: any, currentProject: any) {
        CrossSectionBounds.viewBounds = [];
        if (!ViewerEvents.currentProject || ViewerEvents.currentProject === null) {
            return;
        }
        viewMeta.forEachLayer(function (layer: any) {
            if (typeof layer.id !== "undefined") {
                var entity = currentProject[layer.id];
                if (
                    typeof entity !== "undefined" &&
                    typeof entity.aabb_min_x !== "undefined" &&
                    typeof entity.aabb_max_x !== "undefined" &&
                    typeof entity.aabb_min_y !== "undefined" &&
                    typeof entity.aabb_max_y !== "undefined" &&
                    typeof entity.aabb_min_z !== "undefined" &&
                    typeof entity.aabb_max_z !== "undefined"
                ) {
                    var blockHistogram = [];
                    var blockCount = parseInt(entity.block_info_count) || 0;
                    for (var i = 0; i < blockCount; i++) {
                        if (
                            typeof entity["block" + i + "_dim_x"] !== "undefined" &&
                            typeof entity["block" + i + "_dim_y"] !== "undefined" &&
                            typeof entity["block" + i + "_dim_z"] !== "undefined"
                        ) {
                            blockHistogram.push([
                                parseFloat(entity["block" + i + "_dim_x"]),
                                parseFloat(entity["block" + i + "_dim_y"]),
                                parseFloat(entity["block" + i + "_dim_z"]),
                            ]);
                        }
                    }
                    if (blockHistogram.length > 0) {
                        CrossSectionBounds.viewBounds.push({
                            layerId: layer.id,
                            id: entity.ID,
                            name: entity.name,
                            blocks: blockHistogram,
                            aabb: [
                                [
                                    parseFloat(entity.aabb_min_x),
                                    parseFloat(entity.aabb_min_y),
                                    parseFloat(entity.aabb_min_z),
                                ],
                                [
                                    parseFloat(entity.aabb_max_x),
                                    parseFloat(entity.aabb_max_y),
                                    parseFloat(entity.aabb_max_z),
                                ],
                            ],
                        });
                    }
                }
            }
        });
        // cross section
        var minBlockSize = 10000000000.0;
        var selectedBlock = null;
        var selectedLayerId = "";
        var selectedAABB = null;
        var selectedIndex = -1;
        ViewerActions.viewBounds = CrossSectionBounds.viewBounds;
        for (var b in CrossSectionBounds.viewBounds) {
            var bounds = CrossSectionBounds.viewBounds[b];
            for (var i in bounds.blocks) {
                var size = bounds.blocks[i][0] * bounds.blocks[i][1] * bounds.blocks[i][2];
                if (size < minBlockSize) {
                    minBlockSize = size;
                    selectedBlock = bounds.blocks[i];
                    selectedLayerId = bounds.layerId;
                    selectedAABB = bounds.aabb;
                    selectedIndex = parseInt(i);
                }
            }
        }
        CrossSectionBounds.viewBounds.selectedIndex = selectedIndex;
        CrossSectionBounds.viewBounds.selectedLayerId = selectedLayerId;

        if (selectedBlock !== null && selectedAABB !== null) {
            CrossSectionBounds.setCrossSectionBounds(selectedLayerId, selectedAABB, selectedBlock, true);
        } else {
            //To verify what default value the panel uses
            CrossSectionBounds.setCustomCrossSectionBounds([3.0, 3.0, 3.0], true);
        }
        CrossSectionBounds.initializeBounds = true;
    }

    static setCrossSectionBounds(layerId: string, aabb: any, block: number[], onLoad: boolean) {
        var viewer = ViewerEvents.viewer;
        if (viewer) {
            const layerChanged: boolean = layerId !== CrossSectionBounds.previousCrossSectionBoundsLayerId;
            const recenterPlanes: boolean = onLoad || layerChanged;
            viewer.updateCrossSectionBlockBoundsAndDimension(aabb, block, recenterPlanes);

            CrossSectionBounds.previousCrossSectionBoundsLayerId = layerId;
        }
    }

    static setCustomCrossSectionBounds(block: number[], onLoad: boolean) {
        var viewer = ViewerEvents.viewer;
        if (viewer) {
            const recenterPlanes: boolean = onLoad;
            viewer.updateCrossSectionCustomBlockDimension(block, recenterPlanes);
            CrossSectionBounds.previousCrossSectionBoundsLayerId = "";
        }
    }
    static getCrossSectionBounds() {
        return this.crossSectionBounds;
    }

    static resetCrossSectionBounds() {
        CrossSectionBounds.crossSectionBounds = JSON.parse(JSON.stringify(initialCrossSectionBounds));
    }
    static setInitialValue(name: any, property: any, value: any) {
        CrossSectionBounds.crossSectionBounds[name][property] = value;
    }

    static refreshCrossSectionPositionSlider(
        planeId: string,
        minValue: number,
        maxValue: number,
        stepValue: number,
        value: number
    ) {
        const sliderId = planeId + "Position";
        CrossSectionBounds.setInitialValue(sliderId, "min", minValue);
        CrossSectionBounds.setInitialValue(sliderId, "max", maxValue);
        CrossSectionBounds.setInitialValue(sliderId, "step", stepValue);
        CrossSectionBounds.setInitialValue(sliderId, "value", value);
        EventsEmitter.emit("updateSliders", {});
    }

    static refreshCrossSectionDipSlider(planeId: string, value: number) {
        //Unchanged min, max and step values
        const sliderId = planeId + "Dip";
        CrossSectionBounds.setInitialValue(sliderId, "value", value);
    }

    static refreshCrossSectionDipAzimuthSlider(planeId: string, value: number) {
        //Unchanged min, max and step values
        const sliderId = planeId + "DipAzimuth";
        CrossSectionBounds.setInitialValue(sliderId, "value", value);
    }
}
